import React from "react";
import './Navbar.css'
import Toggle from "../Toggle/Toggle";
import {Link} from 'react-scroll'
function Navbar() {
  return (
    <div className="n-wrapper" id="Navbar">
      <div className="n-left">
        <div className="n-name">Ranjeet</div>
        <Toggle/>
      </div>

      <div className="n-right">
        <div className="n-list">
          <ul  style={{listStyleType:'none'}} >
            <Link spy={true} to="Navbar" smooth={true} activeClass="'activeClass">
            <li>Home</li>
            </Link>


            <Link spy={true} to="Services" smooth={true} activeClass="'activeClass">
            <li>Skills</li>
            </Link>


            <Link spy={true} to="Projects" smooth={true} activeClass="'activeClass">
            <li>Projects</li>
           
            </Link>

            <Link spy={true} to="coding" smooth={true} activeClass="'activeClass">
         
            <li>Coding Profile</li>
           
            </Link>
           
            
         
          </ul>
        </div>
        <Link spy={true} to="Contact" smooth={true} activeClass="'activeClass">
         
        <button className="button n-button">
          Contact US
        </button>
            </Link>

      </div>
    </div>
  );
}

export default Navbar;
